import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { CURRENCIES, DEFAULT_CURRENCY } from '@/constants';

import { AmountFilter, InputStyles, SelectStyles } from './AmountInput.styles';

const numberInputDisabledKeys = [69, 107, 109, 110, 188, 190];

export const handleNumberInputKeyDown = (event) => {
  if (numberInputDisabledKeys.includes(event.keyCode)) {
    event.preventDefault();
  }
};

function AmountInput({
  handleInputChange,
  handleSelectChange,
  amount = '',
  currency = DEFAULT_CURRENCY,
  ...rest
}) {
  const { formatMessage } = useIntl();
  const termOptionsItems = Object.keys(CURRENCIES).reduce((res, cur) => {
    res.push({
      value: cur,
      label: CURRENCIES[cur],
    });

    return res;
  }, []);

  return (
    <AmountFilter>
      <InputStyles
        id="amount-input"
        name="amount"
        type="number"
        min="0"
        value={amount}
        onChange={handleInputChange}
        placeholder={formatMessage({
          id: `productCard.amount.${currency}`,
        })}
        onKeyDown={handleNumberInputKeyDown}
        pattern="\d*"
        {...rest}
      />

      <SelectStyles
        type="radio"
        name="currency"
        options={termOptionsItems}
        value={currency}
        onChange={handleSelectChange}
      />
    </AmountFilter>
  );
}

AmountInput.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
};

export default memo(AmountInput);
